import { createContext } from "react";

export interface SurveyContextValue {
  isSurvey: boolean;
}

export const SurveyContext = createContext<SurveyContextValue>({ isSurvey: false });
